import { render, staticRenderFns } from "./ParticipantesList.vue?vue&type=template&id=25a5fb5d&scoped=true&"
import script from "./ParticipantesList.vue?vue&type=script&lang=js&"
export * from "./ParticipantesList.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantesList.vue?vue&type=style&index=0&id=25a5fb5d&lang=scss&scoped=true&"
import style1 from "./ParticipantesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a5fb5d",
  null
  
)

export default component.exports